import * as Yup from "yup";

export const Schema = Yup.object().shape({
    title: Yup.string().required("فیلد عنوان الزامی می باشد"),
});
